var _rect, _path, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedEnvelopeHiddenModel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    fill: "url(#paint0_linear_771_4442)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26607 9.42683L7.30563 9.48326L7.73404 10.0673C7.84297 10.216 7.987 10.3302 8.15097 10.398V14.5C7.98699 14.4323 7.84296 14.318 7.73404 14.1693L4.29627 9.48326C4.19589 9.34665 4.11715 9.19305 4.06326 9.02868H7.07238C7.1183 9.16842 7.18278 9.30264 7.26607 9.42683ZM12.7037 9.48326L9.26596 14.1693C9.16093 14.3123 9.02904 14.4177 8.88396 14.4844V10.3827C9.01704 10.3215 9.13579 10.2289 9.23152 10.1119L9.26571 10.0673L9.69437 9.48326C9.79475 9.34665 9.87348 9.19305 9.92738 9.02868H12.9367C12.8828 9.19305 12.8041 9.34665 12.7037 9.48326ZM9.10646 2.66084C9.16559 2.71132 9.21911 2.76901 9.26596 2.83276L12.7037 7.51885C12.8571 7.72753 12.959 7.97471 13 8.23738H9.99064C9.95334 7.99831 9.8655 7.77175 9.73393 7.57528L9.69437 7.51885L9.26596 6.93481C9.16491 6.79684 9.03351 6.68834 8.88371 6.61918V2.56829C8.88371 2.55036 8.88249 2.5327 8.88054 2.51556C8.95943 2.55194 9.03563 2.6002 9.10646 2.66084ZM8.15635 2.5C8.15274 2.52256 8.15094 2.5454 8.15097 2.56829V6.60415C8.00389 6.66465 7.87262 6.76283 7.76848 6.89024L7.73429 6.93481L7.30563 7.51885C7.15229 7.72753 7.05037 7.97471 7.00936 8.23738H4C4.041 7.97471 4.14293 7.72753 4.29627 7.51885L7.73404 2.83276C7.84149 2.68595 7.98332 2.57279 8.14487 2.50501L8.15635 2.5Z",
    fill: "#F9E0B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    stroke: "url(#paint1_linear_771_4442)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_771_4442",
    x1: 8.5,
    y1: 1,
    x2: 8.5,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_771_4442",
    x1: 8.5,
    y1: 1,
    x2: 8.5,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECBE73"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedEnvelopeHiddenModel);
export default __webpack_public_path__ + "static/media/red-envelope-hidden-model.c5d5d375.svg";
export { ForwardRef as ReactComponent };